import { createGlobalStyle } from "styled-components"

export const GlobalStyle = createGlobalStyle`
    :root{
        --font-size: 1.25rem;
        --primary-white: #fff;
        --primary-dark: #000;
        --navy-blue: #191970;
        --background-color : var(--primary-white);
        --text-color: var(--primary-dark);
        --footer-color: #FFF;
        --footer-scnd: #111;
    }

    *, *::before, *::after{
        box-sizing: border-box;
        font-family: 'Fira Sans', sans-serif;
    }

    body{
        margin: 0;
        padding: 0;
        font-size: var(--font-size);
        background-color: var(--background-color);
        color: var(--text-color);

        ul{
            list-style-type: none;
            margin: 0;
            padding: 0;
        }

        a{
            text-decoration: none;
            color: inherit;
        }
        a:hover{
            color: var(--navy-blue);
            font-weight: 500;
            transition: all 0.1s ease-in;
            /* text-shadow: 0px 3px 5px rgba(150, 150, 150, 0.7); */
            /* -webkit-animation: text-shadow-drop-center 0.1s both;
	        animation: text-shadow-drop-center 0.1s both;
         */
        }
        .bold{
            font-weight: 700;
        }
    }

    @-webkit-keyframes text-shadow-drop-center {
        0% {
            text-shadow: 0 0 0 rgba(0, 0, 0, 0);
        }
        100% {
            text-shadow: 0 3px 5px rgba(150, 150, 150, 0.7);
        }
        }
    @keyframes text-shadow-drop-center {
        0% {
            text-shadow: 0 0 0 rgba(0, 0, 0, 0);
        }
        100% {
            text-shadow: 0 3px 5px rgba(150, 150, 150, 0.7);
        }
        }
`
